import { useQuery } from "react-query";
import axios from "infra/http";
import { UnidadesDashboard } from './typings/unidade'
import { PaginateQuery } from 'resources/types/shared';


function useDashboardUnidades(query: PaginateQuery) {
    return useQuery(
        [`/v1/unidades/dashboard`, query],
        async () => {
            const { data } = await axios.get<UnidadesDashboard>(
                `/v1/unidades/dashboard`, {
                params: query
            }

            );

            return data;
        },

    );
}

export default useDashboardUnidades;
